import { SecuritiesSyncer } from './securitiesSync'
import type { SecuritiesWorkerMessage, SecuritiesWorkerRequest } from './types'

// Typed narrowly so this file compiles under the app's DOM lib without pulling in "webworker".
const ctx = self as unknown as {
    postMessage(message: SecuritiesWorkerMessage): void
    onmessage: ((event: MessageEvent<SecuritiesWorkerRequest>) => void) | null
}

const syncer = new SecuritiesSyncer()

ctx.onmessage = (event) => {
    const request = event.data
    void (async () => {
        try {
            if (request.type === 'load') {
                ctx.postMessage({ type: 'stored', stored: await syncer.loadStored(), postedAt: Date.now() })
            } else if (request.type === 'revalidate') {
                const outcome = await syncer.revalidate(request, (snapshot, validator) =>
                    ctx.postMessage({ type: 'snapshot', snapshot, validator, postedAt: Date.now() }),
                )
                ctx.postMessage({ type: 'revalidated', outcome, postedAt: Date.now() })
            }
        } catch (error) {
            ctx.postMessage({ type: 'error', message: error instanceof Error ? error.message : String(error) })
        }
    })()
}
